var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectronics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_15",
    "data-name": "Mask Group 15",
    transform: "translate(-324 -303)",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4617",
    "data-name": "Group 4617",
    transform: "translate(-629.734 207.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3662",
    "data-name": "Rectangle 3662",
    width: 2.667,
    height: 1.667,
    transform: "translate(955.738 96.256)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14964",
    "data-name": "Path 14964",
    d: "M290.161,242.317a2,2,0,0,0-2,2v3.667h4v-3.667a2,2,0,0,0-2-2Z",
    transform: "translate(680.243 -134.062)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3663",
    "data-name": "Rectangle 3663",
    width: 2.667,
    height: 1.667,
    transform: "translate(969.072 113.922)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14965",
    "data-name": "Path 14965",
    d: "M35.648,12.026V3.667a3.667,3.667,0,1,0-7.333,0V16.33a3,3,0,1,1-6,0V7.973a2.335,2.335,0,0,0,2-2.307V2a.333.333,0,0,0-.333-.333h-.333V.333A.333.333,0,0,0,23.314,0H20.645a.333.333,0,0,0-.333.333V1.667h-.333A.333.333,0,0,0,19.646,2V5.666a2.335,2.335,0,0,0,2,2.307v8.36a3.667,3.667,0,1,0,7.333,0V3.667a3,3,0,0,1,6,0v8.359a2.335,2.335,0,0,0-2,2.307V18a.333.333,0,0,0,.333.333h.333v1.333a.333.333,0,0,0,.333.333h2.667a.333.333,0,0,0,.333-.333V18.333h.333A.333.333,0,0,0,37.645,18V14.333A2.335,2.335,0,0,0,35.648,12.026ZM20.981.667h2v1h-2Zm-.666,5V2.333h3.333V5.666a1.667,1.667,0,1,1-3.334,0Zm16,13.667h-2v-1h2Zm.667-1.667H33.648V14.333a1.667,1.667,0,1,1,3.334,0v3.333Z",
    transform: "translate(935.089 95.922)",
    fill: "#5d5d5d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/electronics.b3073c8b693979cd57bb4e9dc3900d45.svg";
export { ForwardRef as ReactComponent };